import React, { useEffect, useState } from 'react';
import { Button, Modal, Col, Row } from 'react-bootstrap';
import { Checkbox } from 'pretty-checkbox-react';

import 'pretty-checkbox';

import { sortBy } from 'lodash';

const styles = {
  check: {
    fontSize: '1.25em',
    marginBottom: '0.5em',
  },
  checkLabel: {
    fontSize: '1rem',
    position: 'relative',
    top: '-0.25em',
  },
  row: {
    paddingLeft: '2em',
  },
};

function AccountSelectModal(props) {
  const {
    show,
    onHide,
    accounts,
    accountIds,
    selectedAccounts,
    setSelectedAccounts,
    setNonSelectedAccounts,
  } = props;

  const [localSelected, setLocalSelected] = useState([...selectedAccounts]);
  const [sortedAccounts, setSortedAccounts] = useState([]);

  useEffect(() => {
    setSortedAccounts(
      sortBy(Object.values(accounts), [
        function (build) {
          return build.id !== 'total';
        },
        'name',
      ])
    );
  }, [accounts]);

  useEffect(() => {
    //reset on open
    if (show) {
      setLocalSelected([...selectedAccounts]);
    }
  }, [accountIds, selectedAccounts, show]);

  const updateLocalSelected = (id) => {
    let temp_selected = [...localSelected];

    const found = temp_selected.indexOf(id);

    if (found !== -1) {
      temp_selected.splice(found, 1);
    } else {
      temp_selected.push(id);
    }
    setLocalSelected(temp_selected);
  };

  const updateAccounts = () => {
    setSelectedAccounts(localSelected);
    let tempNonSelectedAccounts = [];
    accountIds.forEach((acc) => {
      if (!localSelected.includes(acc)) {
        tempNonSelectedAccounts.push(acc);
      }
    });
    setNonSelectedAccounts(tempNonSelectedAccounts);
    onHide();
  };

  const makeAccountColumn = (accounts) => {
    return accounts.map((acc) => (
      <Row key={acc.id}>
        <Col md={1}>
          <Checkbox
            style={styles.check}
            color={'primary-o'}
            onChange={() => {
              updateLocalSelected(acc.id);
            }}
            checked={localSelected.includes(acc.id)}
            key={acc.id}
          >
            {''}
          </Checkbox>
        </Col>
        <Col md={11}>
          <div style={styles.checkLabel}>{acc.name}</div>
        </Col>
      </Row>
    ));
  };

  return (
    <Modal show={show} onHide={onHide} size='lg'>
      <Modal.Header closeButton>Select Accounts</Modal.Header>
      <Modal.Body style={{ maxHeight: '500px', overflowY: 'auto' }}>
        <Row style={styles.row}>
          <Col lg={6} xs={12}>
            {makeAccountColumn(
              sortedAccounts.slice(0, Math.ceil(sortedAccounts.length / 2))
            )}
          </Col>
          <Col lg={6} xs={12}>
            {makeAccountColumn(
              sortedAccounts.slice(
                Math.ceil(sortedAccounts.length / 2, sortedAccounts.length)
              )
            )}
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <div style={{ width: '100%' }}>
          <Button
            className='float-left ml-3'
            onClick={() => setLocalSelected([])}
          >
            {' '}
            Deselect All
          </Button>
          <Button
            className='float-left ml-3'
            onClick={() => setLocalSelected([...accountIds])}
          >
            {' '}
            Select All
          </Button>

          <Button
            className='float-right ml-3'
            onClick={() => updateAccounts()}
            disabled={localSelected.length === 0}
            title={
              localSelected.length === 0 ? 'One selection required.' : null
            }
          >
            {' '}
            Confirm
          </Button>
          <Button
            className='float-right ml-3'
            type='button'
            variant='outline-danger'
            onClick={() => onHide()}
          >
            Cancel
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}

export default AccountSelectModal;
